// extracted by mini-css-extract-plugin
module.exports = {"publication":"_4f720283bf--publication--aSAUv","desktop":"_4f720283bf--desktop--Gub2K","packages":"_4f720283bf--packages--nsJ5C","mobile":"_4f720283bf--mobile--JsZl9"};